module.exports = __webpack_public_path__ + "static/BBIS-heat-pump-diagram-min-56c27115a8ae5eb0df9b3fa9c34c12a0.jpg";